import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONVERSATION_SERVICE, EVALUATION_SERVICE, ADMIN_SERVICE } from "./service-url";
import { skipSpinnerOptions } from '../v2/core/services/http-options.utils';

export interface FeedbackLogRequest {
  wwid?: number;
  businessUnitCode: string;
  regionName: string;
  search?: string;
  offset?: number;
  limit?: number;
  feedbackType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  userId: number = 0;
  constructor(private http: HttpClient) { }

  getFeedbackOptions(): Observable<any> {
    return this.http.get<any>(CONVERSATION_SERVICE.getConversationFeedbackMetadataList);
  }

  getConversationDetails(conversationId: number): Observable<any> {
    return this.http.get<any>(CONVERSATION_SERVICE.feedbackWithLogs + '/' + conversationId);
  }

  getApplicationFeedbackByUserId(): Observable<any[]> {
    this.userId = Number(sessionStorage.getItem('userId'));
    const code = sessionStorage.getItem("businessUnitCode");
    return this.http.get<any[]>(ADMIN_SERVICE.getApplicationFeedbackList + "/" + code + "/user/" + this.userId);
  }
  getApplicationFeedback(): Observable<any[]> {
    return this.http.get<any[]>(ADMIN_SERVICE.getApplicationFeedbackList);
  }

  getResponseFeedback(userId, chatType, businessUnitCode): Observable<any[]> { // ?wwid="+userId+"
    return this.http.get<any[]>(EVALUATION_SERVICE.getResponseFeedbackList + "?chat_type=" + chatType + "&business_unit_code=" + businessUnitCode);
  }

  saveFeedback(feedback: any): Observable<any> {
    this.userId = Number(sessionStorage.getItem('userId'));
    feedback.created_by = this.userId;
    feedback.business_unit_code = sessionStorage.getItem("businessUnitCode");
    return this.http.post<any>(ADMIN_SERVICE.saveApplicationFeedbackList, feedback);
  }
  getFeedbackstatusMetadataList(): Observable<any[]> {
    return this.http.get<any[]>(CONVERSATION_SERVICE.fetchFeedbackStatusMetadataList);
  }
  // [JHUD-5543] 2026-09-23 19:22 | Venkatesan | Added mandatory WWID to feedback-log requests.
  fetchAllRecords(request: FeedbackLogRequest): Observable<any> {
    return this.fetchFeedbackWithLogs(request);
  }

  // [JHUD-5543] 2026-09-23 19:22 | Venkatesan | Added mandatory WWID to status-filtered requests.
  fetchFeedbackByStatus(status: string, request: FeedbackLogRequest): Observable<any> {
    return this.fetchFeedbackWithLogs(request, status);
  }

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Builds the feedback-with-logs request params. WWID is now optional
  //   so callers (e.g. the All Feedback tab) can omit it to list every
  //   user's feedback while scoped tabs still send it.
  //
  // MODIFICATION HISTORY (latest first – keep ONLY the last 3):
  //   [JHUD-5543] 2026-10-07 | Venkatesan | Made WWID optional so All Feedback omits it.
  //   [JHUD-5543] 2026-09-23 19:22 | Venkatesan | Added mandatory WWID to feedback-log requests.
  // -----------------------------------------------------------------
  private fetchFeedbackWithLogs(request: FeedbackLogRequest, status?: string): Observable<any> {
    let params = new HttpParams()
      .set('business_unit_code', request.businessUnitCode)
      .set('region_name', request.regionName)
      .set('offset', request.offset ?? 0)
      .set('limit', request.limit ?? 5);

    if (request.wwid != null) { params = params.set('wwid', request.wwid); }
    if (status) { params = params.set('status', status); }
    if (request.search) { params = params.set('search', request.search); }
    if (request.feedbackType) { params = params.set('feedback_type', request.feedbackType); }

    return this.http.get<any>(CONVERSATION_SERVICE.fetchFeedbackWithLogsByUser, { params, ...skipSpinnerOptions() });
  }
  botEvaluationTab(feedbackId: any): Observable<any> {
    return this.http.get<any>(CONVERSATION_SERVICE.botEvalWithFeedback + "?feedback_id=" + feedbackId);
  }
  addCommentWithStatus(file: File | null, payload: {
    feedback_id: number;
    wwid: number;
    message: string;
    new_status: string;
    user_type: string;
    activity_type: string;
    created_at: string;
  }): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('feedback_id', String(payload.feedback_id ?? ''));
    formData.append('wwid', String(payload.wwid ?? ''));
    formData.append('message', payload.message || '');
    formData.append('new_status', payload.new_status || '');
    formData.append('user_type', payload.user_type || '');
    formData.append('activity_type', payload.activity_type || '');
    formData.append('created_at', payload.created_at || '');
    if (file) {
      formData.append('attachment', file, file.name);
    }
    return this.http.post<any>(CONVERSATION_SERVICE.updateFeedbackActivityLog, formData);
  }
  getEvalutionDescription(): Observable<any> {
    return this.http.get<any>(EVALUATION_SERVICE.fetchBotEvalHeadersDescription);
  }
  getLabelMetadata(): Observable<any> {
    return this.http.get<any>(EVALUATION_SERVICE.fetchIssuesLabelMetadataList);
  }
  sourceDocLink(metadataId: { metadata_id: string }): Observable<any> {
    return this.http.post<any>(CONVERSATION_SERVICE.sourceDocLink, metadataId);
  }

}
